function Report(axios, baseUrl) {

    this.axios = axios;
    this.baseUrl = `${baseUrl}report`;

    this.get = function (appointmentUsersId) {
        let self = this;
        return self.axios.get(`${self.baseUrl}/${appointmentUsersId}`);
    }
    this.appointmentReports = function (appointmentId) {
        let self = this;
        return self.axios.get(`${self.baseUrl}/appointmentReports/${appointmentId}`);
    }
    this.add = function (model) {
        let self = this;
        return self.axios.post(`${self.baseUrl}`, model);
    }
    this.update = function (model) {
        let self = this;
        return self.axios.put(`${self.baseUrl}`, model);
    }
    this.remove = function (id) {
        let self = this;
        return self.axios.delete(`${self.baseUrl}/${id}`);
    }
}

export default Report